import styled from 'styled-components/native';

export const BaseSafeAreaView = styled.SafeAreaView`
  flex: 1;
  background-color: ${({ theme }) => theme.colors.background[0]};
`;
